import { render, staticRenderFns } from "./InvoiceViewer.vue?vue&type=template&id=053cfa45&"
import script from "./InvoiceViewer.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports